import * as React from 'react';
import { CardHeader, styled } from '@mui/material';
import Row from 'src/frontend-common/components/Row';
import Card from 'src/frontend-common/components/Card';
import { CustomerPreview } from 'src/frontend-common/dto/Interfaces/ICustomerPreview';
import { noop } from 'src/utils/functions';
import SeeMoreLink from 'src/components/SeeMoreLink';
import { GetCustomersSort } from 'src/frontend-common/dto/Types/CustomerSortFieldType';
import { FilteredTableStructure, NavigateCallbackFn } from 'src/frontend-common/dto/Interfaces/FrontendLookups';
import CustomerListWrapper from 'src/components/CustomerListWrapper';

export const TopWrapper = styled(Card)(() => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
}));

interface Props {
  title: string;
  sort?: GetCustomersSort;
  customers: CustomerPreview[];
  tableStructure: FilteredTableStructure;
  seeMoreToPath: string;
  navigateTo: NavigateCallbackFn;
}

const OverviewCustomerList: React.FC<Props> = ({ title, sort, customers, tableStructure, seeMoreToPath, navigateTo }) => (
  <TopWrapper>
    <CardHeader title={title} />
    <CustomerListWrapper
      noHeader={false}
      sort={sort ?? 'dateAsc'}
      setSort={noop}
      state="ready"
      customers={customers}
      tableStructure={tableStructure}
      navigateTo={navigateTo}
    />
    <>
      {customers.length > 0 && (
        <FooterRow testId="customer-list">
          <SeeMoreLink to={sort ? (`${seeMoreToPath}sort=${sort}` as const) : seeMoreToPath} />
        </FooterRow>
      )}
    </>
  </TopWrapper>
);

export default OverviewCustomerList;

const FooterRow = styled(Row)(({ theme }) => ({
  padding: theme.spacing(2, 3),
  display: 'flex',
  justifyContent: 'flex-end',
}));
